<template>
  <v-row>
    <v-col class="py-0">
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="6"
            sm="4"
            md="2"
          >
            <v-text-field
              v-model="screen.order"
              label="Порядковый номер экрана"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="confType === ConfigurationTypeEnum.Azs"
        >
          <v-col
            cols="12"
            md="12"
          >
            <v-checkbox
              v-model="data.gas.show_first_screen"
              label="Отображать экран"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.toolbar"
              label="Цвет тулбара"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logo"
              label="Логотип"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo_width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logo_height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-checkbox
              v-model="screen.logo_only"
              label="Изображение - во весь экран"
            />
          </v-col>
        </v-row>
        <v-row v-if="confType === ConfigurationTypeEnum.Vending">
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.picture"
              label="Картинка"
              :btn_text="'Загрузить картинку'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.pictureWidth"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.pictureHeight"
              label="Высота изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-checkbox
              v-model="screen.pictureOnly"
              label="Изображение - во весь экран"
            />
          </v-col>
        </v-row>
        <v-row v-if="confType === ConfigurationTypeEnum.Vending">
          <v-col>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <upload-media-files
                  v-model="screen.audio"
                  audio
                  label="Аудио"
                />
              </v-col>
              <v-col
                v-if="isAudioLoaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.audioData.timeout"
                  type="number"
                  label="Таймаут перед проигрыванием аудио (сек)"
                />
              </v-col>
              <v-col
                v-if="isAudioLoaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.audioData.duration"
                  type="number"
                  label="Длительность проигрывания аудио (сек)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
              >
                <v-radio-group v-model="screen.audioData.playEndless">
                  <v-radio
                    label="Проигрывать один раз"
                    :value="false"
                  />
                  <v-radio
                    label="Проигрывать бесконечно"
                    :value="true"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
              >
                <upload-media-files
                  v-model="screen.video1"
                  label="Видео 1"
                />
              </v-col>
              <v-col
                v-if="isVideo1Loaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.videoData1.timeout"
                  type="number"
                  label="Таймаут перед проигрыванием видео (сек)"
                />
              </v-col>
              <v-col
                v-if="isVideo1Loaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.videoData1.duration"
                  type="number"
                  label="Длительность проигрывания видео (сек)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
              >
                <upload-media-files
                  v-model="screen.video2"
                  label="Видео 2"
                />
              </v-col>
              <v-col
                v-if="isVideo2Loaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.videoData2.timeout"
                  type="number"
                  label="Таймаут перед проигрыванием видео (сек)"
                />
              </v-col>
              <v-col
                v-if="isVideo2Loaded"
                cols="12"
                sm="2"
                md="3"
              >
                <v-text-field
                  v-model="screen.videoData2.duration"
                  type="number"
                  label="Длительность проигрывания видео (сек)"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="confType !== ConfigurationTypeEnum.PosPoint"
        >
          <v-col cols="12">
            Текст 1
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text1.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text1.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text1.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="confType !== ConfigurationTypeEnum.PosPoint"
        >
          <v-col cols="12">
            Текст 2
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.text2.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.text2.text"
              label="Текст"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong>Кнопки</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.buttons.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.buttons.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.buttons.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.buttons.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            v-if="confType !== ConfigurationTypeEnum.PosPoint"
            cols="12"
            md="12"
          >
            <v-select
              v-model="screen.buttons.label_type"
              label="Текст на кнопке"
              :items="[
                {
                  value: 0, text: 'Сумма'
                },
                {
                  value: 1, text: 'Количество'
                },
                {
                  value: 2, text: 'Описание'
                }
              ]"
            />
          </v-col>
          <v-col
            v-if="confType !== ConfigurationTypeEnum.PosPoint"
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.buttons.label"
              label="Текст кнопки для свободного ввода"
            />
          </v-col>
        </v-row>
        <!-- begin busy button -->
        <v-row>
          <v-col cols="12">
            <strong>Кнопки не активные</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.buttons.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.buttons_busy.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.buttons_busy.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.buttons_busy.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            v-if="confType === ConfigurationTypeEnum.Azs"
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.buttons_busy.stroke"
              label="Дополнительный цвет кнопок"
            />
          </v-col>
          <v-col
            v-if="confType !== ConfigurationTypeEnum.PosPoint"
            cols="12"
            md="12"
          >
            <v-select
              v-model="screen.buttons_busy.label_type"
              label="Текст на кнопке"
              :items="[
                {
                  value: 0, text: 'Сумма'
                },
                {
                  value: 1, text: 'Количество'
                },
                {
                  value: 2, text: 'Описание'
                }]"
            />
          </v-col>
          <v-col
            v-if="confType !== ConfigurationTypeEnum.PosPoint"
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.buttons_busy.label"
              label="Текст кнопки для свободного ввода"
            />
          </v-col>
        </v-row>
        <!-- end busy button -->
      </v-expansion-panel-content>
    </v-col>
  </v-row>
</template>
<script>

import UploadMediaFiles from "@/views/admin/components/UploadMediaFiles.vue"
import { ConfigurationTypeEnum } from "@/views/loyalty/models/justpay-configuration.model"
import { firstScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  components: { UploadMediaFiles },
  model: {
    prop: "screen",
    event: "changeScreen",
  },
  props: {
    confType: {
      type: Number,
      default: 0
    },
    screen: {
      default: () => (firstScreen)
    },
    isAudioLoaded: {
      type: Boolean,
      default: true
    },
    isVideo1Loaded: {
      type: Boolean,
      default: true
    },
    isVideo2Loaded: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ConfigurationTypeEnum () {
      return ConfigurationTypeEnum
    }
  },
  watch: {
    screen () {
      this.$emit('changeScreen', this.screen)
    }
  },
}
</script>

<style scoped>

</style>
